<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-model-item :label="this.language['ispforum.keyword']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="dsKey">
              <a-input v-model="model.dsKey" :placeholder="this.language['basedata.pleaseEnter']+this.language['ispforum.keyword']"   v-if="this.readonly=='1'"></a-input>
              <a-input v-model="model.dsKey" :placeholder="this.language['basedata.pleaseEnter']+this.language['ispforum.keyword']"  readOnly v-if="this.readonly=='2'"></a-input>
            </a-form-model-item>
          </a-col>

          <a-col :span="24">
            <a-form-model-item :label="this.language['datasource.type']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="dataSourceType">
              <j-dict-select-tag type="list" v-model="model.dataSourceType" dictCode="db_type_sync"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="this.language['datasource.url']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="url">
              <a-input v-model="model.url" :placeholder="this.language['basedata.pleaseEnter']+this.language['datasource.url']" ></a-input>


            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="this.language['system.user.name']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="username">
              <a-input v-model="model.username" :placeholder="this.language['basedata.pleaseEnter']+this.language['system.user.name']" ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="this.language['column.password']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="password">
              <a-input v-model="model.password" :placeholder="this.language['basedata.pleaseEnter']+this.language['column.password']" ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="this.language['fd.status']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="state">
              <j-dict-select-tag v-model="model.state" :type="'radio'" dictCode="datasource_status"/>
            </a-form-model-item>
          </a-col>

          <a-col :span="24">
            <a-form-model-item :label="this.language['dataSource.need.tables']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="needTables">
              <a-input v-model="model.needTables" :placeholder="this.language['dataSource.need.tables.desc']" ></a-input>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </j-form-container>
  </a-spin>
</template>


<script>

import {httpAction, getAction} from '@/api/manage'
import {validateDuplicateValue} from '@/utils/util'
import moment from "moment";

export default {
  name: 'DataSourceForm',
  components: {},
  props: {
    //表单禁用
    disabled: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data() {
    return {
      readonly:"1",
      applicationList: [],
      model: {},
      labelCol: {
        xs: {span: 24},
        sm: {span: 5},
      },
      wrapperCol: {
        xs: {span: 24},
        sm: {span: 16},
      },
      confirmLoading: false





      ,
      url: {
        add: "/sys/datasource/add",
        edit: "/sys/datasource/edit",
        queryById: "/sys/ad/queryById"
      }
    }
  },
  computed: {
    language() {
      return this.$store.getters.language
    },
    formDisabled() {
      return this.disabled
    },
    validatorRules() {
      if (this.language) {
        return {
          dsKey: [
            {required: true, message: this.language['ad.must']+this.language['ispforum.keyword']},
            {min: 2, max: 100, message: this.language['common.lengthRange']+' 2 '+this.language['common.to']+' 100 '+this.language['common.character'], trigger: 'blur'}
          ],
          url: [
            {required: true, message:this.language['ad.must']+this.language['datasource.url']},
            {min: 2, max: 1000, message: this.language['common.lengthRange']+' 2 '+this.language['common.to']+' 1000 '+this.language['common.character'], trigger: 'blur'}
          ],
          username: [
            {required: true, message:this.language['ad.must']+this.language['system.user.name']},
            {min: 2, max: 200, message: this.language['common.lengthRange']+' 2 '+this.language['common.to']+' 200 '+this.language['common.character'], trigger: 'blur'}
          ],
          password: [
            {required: true, message:this.language['ad.must']+this.language['column.password']},
            {min: 2, max: 200, message: this.language['common.lengthRange']+' 2 '+this.language['common.to']+' 200 '+this.language['common.character'], trigger: 'blur'}
          ], state: [
            {required: true, message: this.language['ad.must']+this.language['fd.status']},
          ],
          dataSourceType:[
            {required: true, message: this.language['column.pleaseChoose']+this.language['datasource.type']}
          ],
          needTables: [
            {required: true, message:this.language['ad.must']+this.language['dataSource.need.tables']},
            {min: 2, max: 200, message: this.language['common.lengthRange']+' 2 '+this.language['common.to']+' 200 '+this.language['common.character'], trigger: 'blur'}
          ],
        }
      }
    }

  },
  created() {
    //备份model原始值
    this.modelDefault = JSON.parse(JSON.stringify(this.model));
    this.getApplicationList();
  },
  methods: {
    getApplicationList() {
      httpAction("/sys/role/getSysBmApplication", "", "get").then((res) => {
        if (res.success) {
          this.applicationList = res.result;
        }
      })
    },
    add() {
      this.edit(this.modelDefault);
    },
    edit(record) {
      this.model = Object.assign({}, record);
      //public关键字不可编辑，也不能删除
      if(this.model.dsKey=='public'){
        this.readonly='2';
      }else{
        this.readonly='1';
      }
      this.visible = true;
    }

   ,
    submitForm() {
      const that = this;
      // 触发表单验证
      this.$refs.form.validate(valid => {
        if (valid) {
          that.confirmLoading = true;
          let httpurl = '';
          let method = '';
          if (!this.model.id) {
            httpurl += this.url.add;
            method = 'post';
          } else {
            httpurl += this.url.edit;
            method = 'put';
          }


          httpAction(httpurl, this.model, method).then((res) => {
            if (res.success) {
              that.$message.success(res.message);
              that.$emit('ok');
            } else {
              that.$message.warning(res.message);
            }
          }).finally(() => {
            that.confirmLoading = false;
          })
        }

      })
    },
  }
}


</script>